import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import type { WorkspacesCreateParameters } from "@seamapi/http"

export const useCreateWorkspace = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (params: WorkspacesCreateParameters) => {
      const axios = getAuthenticatedAxios()
      const result = await axios.post("/workspaces/create", params)
      return result.data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["workspaces"] })
    },
  })
}
